/**
 * Tipos de la memoria de intentos por ORIGEN de las órdenes SPEI de Suite
 * (feature 125). Es la misma regla que la 124 aplicó a Cards: la llave vive en
 * la PESTAÑA (singleton raíz, solo heap) y se olvida al cerrar sesión y al
 * iniciar un login nuevo; las páginas conservan el candado de envío, la huella y
 * los errores.
 */

/** Orígenes recordados por tipo (individual y lote por separado); se desaloja el usado hace más tiempo. */
export const SPEI_ORDER_ATTEMPTS_CAPACITY = 32;

/**
 * Llave de la individual + la referencia numérica del cuerpo que abrió el
 * intento: entra en la huella, así que proponerla al volver es lo que deja que el
 * mismo destino, monto y concepto formen la MISMA huella (R10).
 */
export interface SpeiIndividualAttemptKeys {
  readonly idempotencyKey: string;
  readonly reference: string;
}

/**
 * Identidad del origen: la `cuentaOrdenante` del cuerpo (lo que banca debita),
 * solo dígitos. El prefijo `spei#` la separa del `nivel#publicId` de Cards.
 * Sin dígitos ⇒ `null`: no hay intento que crear ni consultar (R7).
 */
export function speiOrderNodeOf(cuentaOrdenante: string | null | undefined): string | null {
  const digits = (cuentaOrdenante ?? '').replace(/\D/g, '');
  return digits.length > 0 ? `spei#${digits}` : null;
}
